export default __webpack_public_path__ + "static/media/placeholder_private03-es-web.c8e3f498.png";